import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import { ErrorBoundary } from './components/ErrorBoundary';
import { applyLocale, applyTheme, usePreferences } from './store/preferences';
import './styles/index.css';

// Applied before the first paint so the page never flashes the wrong theme.
const { theme, locale } = usePreferences.getState();
applyTheme(theme);
applyLocale(locale);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ErrorBoundary>
  </StrictMode>
);
